import { defineStore } from 'pinia'


export const useAppStore = defineStore('app', {
    state: () => {
        return {
            iosApp: false,
            allowedMediaTypes: ["sound"],
            storedMedia: []
        }
    },
    getters: {
        inIosApp() {
            return this.iosApp;
        },
        allowedMediaType(mediaType) {
            return this.allowedMediaTypes.includes(mediaType);
        },
        media() {
            return this.storedMedia;
        }
    },
    actions: {
        resetState() {
            this.iosApp = false;
            this.storedMedia = [];

        },
        addMedia(media) {
            this.storedMedia.push(media);
        },
        clearMedia() {
            this.storedMedia.splice(0, this.storedMedia.length);
        },
        setIOSApp() {
            this.iosApp = true;
        }
    },
});
